import type { FormField } from '@/types/form-definition';

/** Payment fields on the same form that use Square — required for `reschedulePaymentFieldId` on appointment fields. */
export function listSquarePaymentFields(fields: FormField[]): { id: string; label: string }[] {
  return fields
    .filter((f) => {
      if (f.type !== 'payment') return false;
      const cfg = f.config;
      if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) return false;
      return (cfg as Record<string, unknown>).gateway === 'square';
    })
    .map((f) => ({
      id: f.id,
      label: (typeof f.label === 'string' && f.label.trim() ? f.label.trim() : 'Payment') + ` · ${f.id.slice(0, 8)}…`,
    }));
}

export function isSquarePaymentField(field: FormField): boolean {
  if (field.type !== 'payment') return false;
  const cfg = field.config;
  if (!cfg || typeof cfg !== 'object' || Array.isArray(cfg)) return false;
  return (cfg as Record<string, unknown>).gateway === 'square';
}
